// Styles ====================================================================
import '../styles/main.scss';
import '@shoelace-style/shoelace/dist/themes/light.css';

// Libs =====================================================================
import 'what-input';
import 'lazysizes';

// Modules ===================================================================
import { buildSizeObserver, convertInertClassToAttribute } from '@js/observers';
import { SharedIndicator, Scrollspy, Gallery } from '@js/components';
import { buildLivestream, buildNotch, setupPrimaryNavigation, setupWebComponents, setupAlerts, setupVideoEmbed } from '@js/setup';

// Components
import { InaugurationEvents, Countdown } from 'id-components';

// Methods
import { useInView } from '@js/methods/useInView';
import { useIsSticky } from '@js/methods/useIsSticky';


// Init =====================================================================
document.addEventListener('DOMContentLoaded', () => {
	// Navigation
	setupPrimaryNavigation();

	// Observer masthead.
	buildSizeObserver(document.querySelector('.masthead'),'masthead', '--masthead-block-size');

	// Observer site-navigation.
	buildSizeObserver(document.querySelector('.site-navigation'),'siteNavigation', '--site-navigation-block-size');

	// Shared Indicator
	document.querySelectorAll('[data-shared-indicator]')?.forEach(el => new SharedIndicator(el));

	// Scrollspy
	document.querySelectorAll('[data-scrollspy]')?.forEach(el => new Scrollspy(el));

	// Gallery
	document.querySelectorAll('[data-gallery]')?.forEach(el => new Gallery(el));

	// Web Components
	setupWebComponents();

	// BuildNotch
	buildNotch();

	// Build Livestream
	buildLivestream();

	// Setup Alerts
	setupAlerts();

	// Setup Video Embed
	setupVideoEmbed();

	// Build Inert
	convertInertClassToAttribute();

	// Use In View
	const inViewElements = document.querySelectorAll('[use-in-view]')
	inViewElements && inViewElements.forEach(el => useInView(el, () => {}, el.getAttribute('use-in-view') ? JSON.parse(el.getAttribute('use-in-view')) : null))

	// Use Is Sticky
	const isStickyElements = document.querySelectorAll('[use-is-sticky]')
	isStickyElements && isStickyElements.forEach(el => useIsSticky(el))
});
